import React from 'react';
import cn from 'classnames';
import Select from 'react-select';
import { connect } from 'react-redux';
// TODO: props
// import PropTypes from 'prop-types';
import { i18n } from '@lt/localization';
import { getCitizenships } from '../../../routes/Checkout/store/selectors/data';
import { px2rem } from '../../../utils/commonUtils';

import TouristField from '../TouristField';
import withMobile from '../../../routes/Checkout/CheckoutRoutes/PackageCheckout/hocs/withMobile';

class TouristCitizenship extends React.PureComponent {
  static SELECT_STYLE = {
    container: (base) => ({ ...base, width: '100%' }),
    placeholder: (base) => ({ ...base, fontSize: 12 }),
    control: () => ({ display: 'flex' }),
    input: () => ({ overflow: 'hidden', width: 0 }),
    menu: (base) => ({
      ...base,
      width: '220px',
      marginTop: '1rem',
      marginLeft: '-.5rem',
    }),
    option: (base) => ({
      ...base,
      whiteSpace: 'nowrap',
      fontSize: 15,
      overflowX: 'hidden',
    }),
    singleValue: () => ({
      fontWeight: 'bold',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: px2rem(14),
    }),
    valueContainer: () => ({
      display: 'flex',
      alignItems: 'center',
      minWidth: 'calc(100% - 15px)',
      maxWidth: 'calc(100% - 15px)',
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base) => ({ ...base, padding: 0, marginLeft: '-5px' }),
  };

  static SELECT_STYLE_MOBILE = {
    ...TouristCitizenship.SELECT_STYLE,
    container: (base) => ({ ...base, minWidth: 'calc(100% + 14px)' }),
    menu: (base) => ({
      ...base,
      width: '100%',
      marginTop: '1rem',
      marginLeft: '-8px',
      zIndex: 5,
    }),
    singleValue: () => ({
      fontWeight: 'bold',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: 18,
    }),
    option: (base) => ({
      ...base,
      fontSize: 15,
      overflowX: 'hidden',
    }),
    dropdownIndicator: (base) => ({ ...base, padding: 0, marginLeft: '-15px' }),
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const { value } = event;
    const { onChange } = this.props;
    onChange(value);
  }

  get selectedOption() {
    const { value, citizenships } = this.props;
    const selected = citizenships.find((option) => option.value === value);
    return selected;
  }

  render() {
    const { citizenships, className, isMobile, ...others } = this.props;
    const styles = isMobile
      ? TouristCitizenship.SELECT_STYLE_MOBILE
      : TouristCitizenship.SELECT_STYLE;
    return (
      <TouristField
        {...others}
        className={cn('tourist-citizenship', className)}
        label={i18n.t('checkout.touristForm.citizenship')}
        items={citizenships}
      >
        <Select
          styles={styles}
          value={this.selectedOption}
          options={citizenships}
          onChange={this.handleChange}
          placeholder={i18n.t('checkout.touristForm.select')}
          noOptionsMessage={() => null}
        />
      </TouristField>
    );
  }
}

TouristCitizenship.propTypes = {};

const mapStateToProps = (state) => ({
  citizenships: getCitizenships(state),
});

export default connect(mapStateToProps)(withMobile(TouristCitizenship));
